import { filter } from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { ApplicationService } from '../../shared/services/application/application.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { BaseComponent } from '../../shared/components/base-component';
import { findInArray, getValueProperty, lastValueFrom, memoize, mergeObjects, setValueProperty } from '../../shared/helpers/functions.helpers';
import { CopyService } from '../../shared/services/copies/copy.service';
import { ControlContainer, FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CatalogService, EStatusBusinessList, IBusinessList } from '../../shared/services/catalogs/catalog.service';
import { TokenService } from '../../shared/services/security/token.service';
import { HttpClient } from '@angular/common/http';
import { NavigationService } from '../../shared/services/navigation/navigation-service.service';
import { EVENT } from '../../shared/constants/dali.constants';
import { camelCase } from 'lodash';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent extends BaseComponent implements OnInit {

  @Input()
  data: any[] = [];

  @Input()
  fileList!: FormArray;

  @Input()
  config: any[] | any;

  @Input()
  requiredDoc: any[] | any;


  fileTypes: Array<any> = [];
  validMIMEtypes: Array<string> = [];
  maxFileSize: number = 2500000;
  maxUploadFiles: number = 5;
  maxUploadTotalSize: number = 12500000;
  fileErrorMessages: any = {};
  fileError: string = '';

  isLoadingFiles = false;

  private _solicitationSettings: any;


  @ViewChild("fileUpload") fileInput!: ElementRef<HTMLInputElement>;
  caption_files: string = '';

  constructor(
    private readonly _link: LinkupService,
    public _app: ApplicationService,
    private readonly _cps: CopyService,
    private readonly _catalog: CatalogService,
    private _token: TokenService,
    private fb: FormBuilder,
    private _http: HttpClient,
    public navigator: NavigationService
  ) {
    super(_app, _link, 'upload-files');
  }

  ngOnInit(): void {
    this.loadStaticValues();
    this.initControls()
      .finally(() => {
        this.loadData();
      });
  }

  /**
  * Permite la carga de textos y listas estaticas
  */

  async solicitationSettings() {
    let resultFiletype = [];
    let resultOnbase = [];
    const SOLICITATION_SETTINGS = await this._catalog.getResourceCatalogSolicitations('solicitation_settings');
    this._solicitationSettings = SOLICITATION_SETTINGS;
    if (SOLICITATION_SETTINGS && Array.isArray(SOLICITATION_SETTINGS)) {
      resultFiletype = this._solicitationSettings.filter((item: any) => item.parent_business_id === "FILE_TYPE");
      resultOnbase = this._solicitationSettings.filter((item: any) => item.parent_business_id === "ONBASE");
      let errorMsgType = "";
      for (let fileSettingKey of Object.keys(resultFiletype)) {
        const item = resultFiletype[fileSettingKey];
        this.fileTypes.push(item);
        let mimeType = findInArray(item.parameters, "key", "mime_type");
        this.validMIMEtypes.push(getValueProperty(mimeType, "value", ""));
        errorMsgType = findInArray(item.parameters, "key", "error_message");
      }
      let errorMsgMaxSize = resultOnbase.filter((value: any) => value.business_id === "MAX_SIZE_FILES");
      errorMsgMaxSize = findInArray(errorMsgMaxSize[0].parameters, "key", "error_message");
      let errorMsgMaxUpload = resultOnbase.filter((value: any) => value.business_id === "MAX_UPLOAD_FILES");
      errorMsgMaxUpload = findInArray(errorMsgMaxUpload[0].parameters, "key", "error_message");
      let errorMessage = {
        "max_length": getValueProperty(errorMsgMaxUpload, "value", ""),
        "max_size": getValueProperty(errorMsgMaxSize, "value", ""),
        "file_type": getValueProperty(errorMsgType, "value", "")
      };
      this.fileErrorMessages = errorMessage;
      let valueMsgMaxSize = resultOnbase.filter((value: any) => value.business_id === "MAX_SIZE_FILES");
      valueMsgMaxSize = findInArray(valueMsgMaxSize[0].parameters, "key", "value");
      this.maxFileSize = getValueProperty(valueMsgMaxSize, 'value', 0);
      let valueMsgMaxUpload = resultOnbase.filter((value: any) => value.business_id === "MAX_UPLOAD_FILES");
      valueMsgMaxUpload = findInArray(valueMsgMaxUpload[0].parameters, "key", "value");
      this.maxUploadFiles = getValueProperty(valueMsgMaxUpload, 'value', 0);
      this.maxUploadTotalSize = this.maxUploadFiles * this.maxFileSize;


      const FILE_SERVICE_SETTING = findInArray(SOLICITATION_SETTINGS, 'business_id', 'FILE_SERVICE');

      if (FILE_SERVICE_SETTING) {
        let fileTypesNames = '';

        let maxSizeFileSetting = resultOnbase.filter((value: any) => value.business_id === "MAX_SIZE_FILES");
        maxSizeFileSetting = findInArray(maxSizeFileSetting[0].parameters, "key", "size_display_length");
        let _FilesLength = getValueProperty(maxSizeFileSetting, 'value', '');

        resultFiletype.map(
          (x: any) => x.business_name.substring(0, x.business_name.indexOf('-') - 1).trim()
        ).map((r: any) => {
          return fileTypesNames += fileTypesNames.indexOf(r) == -1 ? `${r},` : ''
        });

        this.caption_files = this._solicitationSettings.filter((n: any) => n.business_id == 'FILE_SERVICE')
          .map((p: any) => { return p.parameters })
          .flatMap((k: any) => k)
          .filter((r: any) => r.value != '')
          .values()
          .next().value.value.replace('#COUNT', this.maxUploadFiles)
          .replace('#TYPES', fileTypesNames.substring(0, fileTypesNames.length - 1))
          .replace('#LENGTH', _FilesLength);
      }

      /*
      /// ->  INTEGRACION FUNCIONALIDAD CAPTION [FILE_SERVICE] PARAMETRIZABLE --DEBE EXISTIR EN CATALOGO: Extensiones de archivos
      /// ->  FILTRA _SETTINGS ONBASE, ADICIONA LOS PARÁMETROS DE CANTIDAD Y LONGITUD DE ARCHIVOS / 100000
      /// ->  CONTENIDO AGREGADO LN 104...111
      /// ->  OJM05360 - 9-12-22
      */
    }

  }

  async loadStaticValues() {
    await super.loadStaticValues();
    let defaultConfig = await this._cps.getCopy("upload-files");
    this.config = mergeObjects(defaultConfig, this.config);
    /** File upload config */
    this.solicitationSettings();
  }

  /**
 * Permite cargar los datos en memoria
 */
  async loadData() {
    if (this.data && this.data.length > 0) {
      this.fileList.clear();
      for (let files of this.data) {
        this.addFile(files.file, files.settings);
      }
    }
  }

  /**
   * Define los controles disponibles en el formulario
   */
  async initControls() {
    if (!this.navigator.currentStep) {
      this.navigator.startFlow("solicitationSearch");
    }
  }

  @memoize()
  async typeAccept() {
    this._solicitationSettings = await this._catalog.getResourceCatalogSolicitations('solicitation_settings');
    let resultFiletype = this._solicitationSettings.filter((item: any) => item.parent_business_id === "FILE_TYPE");
    let fileAccept: Array<string> = [];
    for (let fileSettingKey of Object.keys(resultFiletype)) {
      const fileSettingItem = resultFiletype[fileSettingKey];
      let extension = findInArray(fileSettingItem.parameters, "key", "extension");
      fileAccept.push(`.${getValueProperty(extension, 'value', 'pdf')}`);
    }
    return fileAccept.join(',');
  }

  async loadFiles($event: any) {

    try {
      this.isLoadingFiles = true;
      let uploadFiles: FileList = getValueProperty($event, 'target.files', undefined);

      this.fileError = '';
      if (uploadFiles && uploadFiles.length <= this.maxUploadFiles && (this.fileList.length + uploadFiles.length) <= this.maxUploadFiles) {

        for (let uploadFile of Object.values(uploadFiles)) {
          if (uploadFile.size <= this.maxFileSize) {

            let fileBuffer = await uploadFile.arrayBuffer();

            let idx = uploadFile.name.lastIndexOf('.');
            let extension: string = uploadFile.name.substring(idx + 1);
            extension = `${extension}`.toLowerCase();
            let resultFiletype = this._solicitationSettings.filter((item: any) => item.parent_business_id === "FILE_TYPE");
            let fileType = null;
            for (let fileSettingKey of Object.keys(resultFiletype)) {
              const item = resultFiletype[fileSettingKey];
              let extensionArray = findInArray(item.parameters, "key", "extension");
              let extensionAct = getValueProperty(extensionArray, "value", "")
              if (extensionAct === extension) {
                let mimeType = findInArray(item.parameters, "key", "mime_type");
                let mimeTypePrefirm = findInArray(item.parameters, "key", "mime_type_prefirmado");
                let onbase_code = findInArray(item.parameters, "key", "onbase_code");
                let errorMsgType = findInArray(item.parameters, "key", "error_message");
                let magicNumber = findInArray(item.parameters, "key", "magic_number");
                fileType = {
                  type: extension,
                  MIMEtype: getValueProperty(mimeType, "value", ""),
                  MIMEtypePrefirm: getValueProperty(mimeTypePrefirm, "value", ""),
                  id: getValueProperty(onbase_code, "value", ""),
                  message: getValueProperty(errorMsgType, "value", ""),
                  typeId: getValueProperty(magicNumber, "value", "")
                };
              }
            }

            if (fileType) {
              let mimeType = getValueProperty(uploadFile, 'type', fileType.MIMEtype);
              if (this.validMIMEtypes.find((x: string) => x == mimeType)) {
                setValueProperty(uploadFile, 'type', mimeType);

                const fileTypeCheck = fileType.typeId;
                if (fileTypeCheck) {

                  let _rs: any = new Uint8Array(fileBuffer.slice(0, 4))
                    .map((x: any) => {
                      return x.toString(16)
                    });

                  let _cqn = btoa(new Uint8Array(_rs.buffer).join(','));

                  if (fileTypeCheck === _cqn) {
                    this.addFile(uploadFile, fileType);
                  } else {
                    this.fileError = getValueProperty(this.fileErrorMessages, 'file_type', '').replace('{type_name}', `${uploadFile.name}`);
                    console.log('error typeId', _cqn);
                  }
                } else {
                  this.addFile(uploadFile, fileType);
                }
              } else {
                this.fileError = getValueProperty(this.fileErrorMessages, 'file_type', '').replace('{type_name}', `${uploadFile.name}`);
                console.log('mime is invalid', mimeType);
              }
            } else {
              this.fileError = getValueProperty(this.fileErrorMessages, 'file_type', '').replace('{type_name}', `${uploadFile.name}`);
              console.log('invalid extension', extension);
            }
          } else {
            console.log('filesize error', uploadFile.size);
            this.fileError = getValueProperty(this.fileErrorMessages, 'max_size', '').replace('{file_name}', `${uploadFile.name}`);
          }
        }
      } else {
        console.log('max upload files count error');
        this.fileError = getValueProperty(this.fileErrorMessages, 'max_length', '').replace('{max_length}', `${this.maxUploadFiles}`);
      }
    } catch (error) {
      this.fileError = getValueProperty(this.fileErrorMessages, 'error', 'Error al procesar');
      if (this.navigator.currentStep.key == "solicitation-data") {
        let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv4E5setData.pv4E5transactionName.path}",
            "value": EVENT.pv4E5setData.pv4E5transactionName.value
          },
          {
            "name": "{EVENT.pv4E5setData.pv4E5transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          }
        ];
        setValueProperty(eventSetting, "events", events);
        let word = camelCase(this.fileError);
        word = word[0].toUpperCase() + word.substring(1);
        setValueProperty(eventSetting, "errorName", word);
        this.onEvent(eventSetting);
      }
    }
    if (this.fileError) {
      if (this.navigator.currentStep.key == "solicitation-data") {
        let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv4E5setData.pv4E5transactionName.path}",
            "value": EVENT.pv4E5setData.pv4E5transactionName.value
          },
          {
            "name": "{EVENT.pv4E5setData.pv4E5transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          }
        ];
        setValueProperty(eventSetting, "events", events);
        let word = camelCase(this.fileError);
        word = word[0].toUpperCase() + word.substring(1);
        setValueProperty(eventSetting, "errorName", word);
        this.onEvent(eventSetting);
      }
    }
    this.fileInput.nativeElement.value = '';
    this.isLoadingFiles = false;
  }

  /**
   *
   */
  async addFile(uploadFile: File, fileType: any) {
    const formFile = this.fb.group({
      'file': this.fb.control(uploadFile),
      'settings': this.fb.control(fileType),
    });
    this.fileList.push(formFile);
  }

  removeFile(index: number) {
    this.fileList.removeAt(index);
    this.fileInput.nativeElement.value = '';
  }

  async downloadFile(file: File) {
    const arrayBuffer = await file.arrayBuffer();
    const fileName = file.name;
    const a = document.createElement('a')
    a.href = URL.createObjectURL(new Blob(
      [arrayBuffer],
      { type: file.type }
    ))
    a.download = fileName
    a.click();
    a.remove();
  }

  async fileChargeEvent() {
    if (this.navigator.currentStep.key == "solicitation-data") {
      let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv4E3setData.pv4E3transactionName.path}",
          "value": EVENT.pv4E3setData.pv4E3transactionName.value
        },
        {
          "name": "{EVENT.pv4E3setData.pv4E3transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
  }
}
